import React from 'react';
import logo from '../img/ido-data-logo-noir-WEB.png';


export const Header = () => {
  return (
    <header>
        <img src={logo} alt="logo ido-data" />
    </header>
  )
}
